import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface User {
    id?: string;
    username?: string;
    email?: string;
    name?: string;
    mobile?: string;
    accessLevel?: string;
    organizationId?: number;
    profile_image?: string;
    [key: string]: any;
}

interface OrganizationBranding {
    organizationId?: number;
    org_name?: string;
    logo?: string;
    logo_dark?: string;
    logo_light?: string;
    logo_sm?: string;
    banner_image?: string;
    favicon?: string;
    [key: string]: any;
}

interface ProfileState {
    user: User;
    branding: OrganizationBranding | null;
    error: string;
    success: boolean;
}

const initialState: ProfileState = {
    user: {},
    branding: null,
    error: "",
    success: false
};

const profileSlice = createSlice({
    name: "profile",
    initialState,
    reducers: {
        profileSuccess(state: ProfileState, action: PayloadAction<User>) {
            state.user = action.payload;
            state.success = true;
        },
        profileFailed(state: ProfileState, action: PayloadAction<string | any>) {
            state.error = action.payload;
            state.success = false;
        },
        setBranding(state: ProfileState, action: PayloadAction<OrganizationBranding>) {
            state.branding = action.payload;
        },
        clearProfile(state: ProfileState) {
            state.user = {};
            state.branding = null;
            state.success = false;
            state.error = "";
        }
    }
})

export const { profileSuccess, profileFailed, setBranding, clearProfile } = profileSlice.actions;
export default profileSlice.reducer;